export enum ReturnRequestType {
    Extension = 'Extension',
    Return = 'Return',
    Service = 'Service',
    Reorder = 'Reorder'
}
